export default __webpack_public_path__ + "assets/favicon.8730ca76d7e772e177778c88fbed5689.png";